/**
 * @desc: - 真人，电游  转账组件
 * @param  {[number]} ：money [余额]
 * @param  {[string]} ：imgname [图片名字Class 真人 zr-playtech zr-ag zr-wm r-bbin  电游dy-playtech dy-ag dy-bbin]
 * @param  {[string]} ：url [链接地址]
 * @author: vico
 */

import React from 'react';

export default class Entrance extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    const {type, money, imgname, url, gameName, transferFn, disabled} = this.props;
    const className = !disabled ? ('zryx_img ' + imgname) : ('zryx_img cursor-default ' + imgname)
    return (
        <div className="entrance-box">
          {
            (gameName==="瓦力棋牌" || gameName==="云游棋牌" || gameName==="KGAME")?
            <a className={className} onClick={url}>
              <span>进入游戏</span>
            </a>
            :
            <a className={className} href={!disabled ? url : 'javascript:'}>
              <span>{disabled ? '敬请期待' : '进入游戏'}</span>
              {type == 'slot' ? <b></b> : null}
            </a> 
          }
          <div className="money-div">
            <p>您当前的{gameName}余额为:</p>
            <p>￥ <span className="money-number">{money ? money : 0}</span></p>
            {
              !disabled ? <a className={"recharge2 " + type} onClick={transferFn}>转账</a> : null
            }
          </div>
        </div>
    )
  }
}
